import {
  sagaListSuccess,
  sagaOneSuccess,
  sagaUpdateSuccess,
  sagaCreateSuccess
} from "../actions/ActionTypes";

import { remove } from "lodash";

const ASSETS = "assets";
const ASSET = "asset";

const initialState = {
  list: [],
  currentAsset: {},
  formVisible: false
};

export default function assets(state = initialState, action = {}) {
  switch (action.type) {
    case "SHOW_ASSET_FORM":
      return { ...state, formVisible: true };
    case "HIDE_ASSET_FORM":
      return { ...state, formVisible: false };
    case sagaListSuccess(ASSETS):
      return { ...state, list: action.data.data };
    case sagaOneSuccess(ASSET):
      return { ...state, currentAsset: action.data.data };
    case sagaCreateSuccess(ASSET):
      let updatedList = [action.data.data, ...state.list];
      return { ...state, list: updatedList, currentAsset: action.data.data };

    case sagaUpdateSuccess(ASSET):
      let updatedAsset = action.data.data;
      remove(state.list, x => x.id === updatedAsset.id);
      let refreshedList = [action.data.data, ...state.list];
      return { ...state, list: refreshedList, currentAsset: action.data.data };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/assets.js